<template>
    <div class="projectAddress-box">
        <van-nav-bar
            title="查看定位"
            left-text=""
            left-arrow
            @click-left="onClickLeft"
        >
        </van-nav-bar>
        <!-- <span class="back iconfont" @click="handleBack">&#xe607;</span> -->
        <div class="container">
            <BaiduMap
                class="map"
                ref="map"
                :center="marker.position"
                :zoom="zoom"
                ak="8oGi1YBeLNnGA54yA1YuyumkzjjfGqmW"
            >
                <bm-marker
                    :position="marker.position"
                >
                    <bm-info-window :position="marker.position" title="" :show="true">
                        <div style="padding-top: 20px">
                            {{ marker.name }}
                        </div>
                    </bm-info-window>
                </bm-marker>
            </BaiduMap>
            <div class="info-con">
                {{ marker.name }}
            </div>
        </div>
    </div>
</template>

<script>
/* eslint-disable */
import { HeaderNav } from '@/components/';
import BaiduMap from 'vue-baidu-map-v3/components/map/Map.vue';
import BmMarker from 'vue-baidu-map-v3/components/overlays/Marker.vue';
import BmInfoWindow from 'vue-baidu-map-v3/components/overlays/InfoWindow.vue';
export default {
    components: {
        HeaderNav,
        BaiduMap,
        BmMarker,
        BmInfoWindow,
    },
    props: {},
    data() {
        return {
            map: null,
            zoom: 12,
            marker: {
                position: {lng: 0, lat: 0},
            },
        }
    },
    watch: {},
    computed: {},
    methods: {
        onClickLeft(){
            this.$router.isBack = 1;
            this.$router.back();
        }
    },
    created() {
        const address = this.$route.params.address;
        const longitude = this.$route.params.longitude || 0;
        const latitude = this.$route.params.latitude || 0;
        this.marker = {
            icon: {},
            offset:{ width: -13, height: -30},
            position: { lng:longitude, lat: latitude },
            name: address
        }
    },
    mounted() {

    }
};
</script>
<style lang="stylus">
.projectAddress-box
    height 100%
    padding-top 0
    .back
        position absolute
        top 10rpx
        left 15rpx
        z-index 10000
        color #fff
    .container
        height calc(100% - 45rpx)
        position relative
        .search
            position absolute
            top 10rpx
            width 100%
            padding 10rpx
            height 40rpx
            z-index 1000
            input
                border 1px solid #D7D7D7
                padding 5rpx!important
                border-radius 5rpx
                overflow hidden
                width 100%
                height 38rpx
        .map
            height 100%
        .info-con
            position absolute
            bottom 0
            width 100%
            height 50rpx
            background #fff
            padding-left 10rpx
            line-height 50rpx
</style>
